"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
exports.__esModule = true;
exports.getOperationsPageSize = void 0;
function getOperationsPageSize(accountId, syncConfig) {
    var paginationConfig = syncConfig.paginationConfig;
    var operationsPerAccountId = paginationConfig.operationsPerAccountId, operations = paginationConfig.operations;
    var numbers = [];
    if (operationsPerAccountId &&
        accountId &&
        accountId in operationsPerAccountId) {
        numbers.push(operationsPerAccountId[accountId]);
    }
    if (typeof operations === "number") {
        numbers.push(operations);
    }
    if (numbers.length === 0)
        return Infinity;
    return Math.max.apply(Math, __spreadArray([], __read(numbers), false));
}
exports.getOperationsPageSize = getOperationsPageSize;
//# sourceMappingURL=pagination.js.map